import { LabelSize } from "./label.types";
import { Skeleton } from "../skeleton/skeleton.component";

export const LabelSkeleton = ({ size }: { size?: LabelSize }) => {
	const height = size === "big" ? "1.5rem" : "1rem";
	return <Skeleton width="5rem" height={height} />;
};
